import React from 'react'

export const INVOICE_FORM_BOTTOM_BAR_BODY_CLASS = 'invoice-form-bottom-bar-visible'
export const INVOICE_FORM_BOTTOM_BAR_OFFSET_VAR = '--invoice-form-bottom-bar-offset'

/** Measures the fixed bottom action bar and sets a body CSS variable for scroll padding. */
export const useInvoiceFormBottomBarOffset = (
  active: boolean,
  barRef: React.RefObject<HTMLElement | null>,
) => {
  React.useLayoutEffect(() => {
    if (!active) {
      document.body.classList.remove(INVOICE_FORM_BOTTOM_BAR_BODY_CLASS)
      document.body.style.removeProperty(INVOICE_FORM_BOTTOM_BAR_OFFSET_VAR)
      return
    }

    document.body.classList.add(INVOICE_FORM_BOTTOM_BAR_BODY_CLASS)

    const updateOffset = () => {
      const bar = barRef.current
      if (!bar) return
      document.body.style.setProperty(
        INVOICE_FORM_BOTTOM_BAR_OFFSET_VAR,
        `${bar.getBoundingClientRect().height}px`,
      )
    }

    updateOffset()
    const observer = new ResizeObserver(updateOffset)
    const bar = barRef.current
    if (bar) observer.observe(bar)
    window.addEventListener('resize', updateOffset)

    return () => {
      document.body.classList.remove(INVOICE_FORM_BOTTOM_BAR_BODY_CLASS)
      document.body.style.removeProperty(INVOICE_FORM_BOTTOM_BAR_OFFSET_VAR)
      observer.disconnect()
      window.removeEventListener('resize', updateOffset)
    }
  }, [active, barRef])
}
